export const HAS_DIVIDENDS_ROW = 4;
export const HAS_COMPOUNDING_ROW = 7;
export const DIVIDEND_RATE_IS_REQUIRED_FEEDBACK = 'Dividend Rate is required.';
export const COMPOUNDING_PERIOD_IS_REQUIRED_FEEDBACK = 'Compounding Period is required.';
export const COMPOUNDING_PERIOD_MIN_VALUE_FEEDBACK = 'Compounding Period must be 1 or greater.';
export const booleanFriendlyOptions = [
  { value: 0, label: 'No' },
  { value: 1, label: 'Yes' },
];
export const MULTIPLE_OF_TITLE = 'Liquidation Preference Multiple Of';
export const MULTIPLE_OF_ALIAS = 'multiple_of';

export const ISSUE_PRICE_VALUE = 0;
export const PRICE_PLUS_DIVIDENDS_VALUE = 1;
export const ISSUE_PRICE_LABEL = 'Issue Price';
export const PRICE_PLUS_DIVIDENDS_LABEL = 'Price + Dividends';

export const MULTIPLE_OF_OPTIONS = [
  { value: ISSUE_PRICE_VALUE, label: ISSUE_PRICE_LABEL, tooltip: 'Preference is multiple of the issue price only' },
  {
    value: PRICE_PLUS_DIVIDENDS_VALUE,
    label: PRICE_PLUS_DIVIDENDS_LABEL,
    tooltip: 'Preference is multiple of the issue price + accrued dividends at exit date',
  },
];

export const YEARFRAC_BASIS_TITLE = 'Dividend YEARFRAC Basis';
export const YEARFRAC_BASIS_ALIAS = 'dividend_yearfrac_basis';
export const BASIS_0_VALUE = 0;
export const BASIS_1_VALUE = 1;
export const BASIS_2_VALUE = 2;
export const BASIS_3_VALUE = 3;
export const BASIS_4_VALUE = 4;
export const BASIS_0_LABEL = 'Actual/Actual';
export const BASIS_1_LABEL = '30/360';
export const BASIS_2_LABEL = 'Actual/360';
export const BASIS_3_LABEL = 'Actual/365';
export const BASIS_4_LABEL = '30/360E';

export const YEARFRAC_BASIS_OPTIONS = [
  { value: BASIS_0_VALUE, label: BASIS_0_LABEL },
  { value: BASIS_1_VALUE, label: BASIS_1_LABEL },
  { value: BASIS_2_VALUE, label: BASIS_2_LABEL },
  { value: BASIS_3_VALUE, label: BASIS_3_LABEL },
  { value: BASIS_4_VALUE, label: BASIS_4_LABEL },
];
